import LazyLoad from "vanilla-lazyload";
import $ from 'jquery';
import 'slick-slider';
let myLazyLoad = new LazyLoad();

$(function(){
    $(document).ready(function () { iframeresize(); });
    $(window).resize(function () { iframeresize(); });

    function iframeresize(){
        $("iframe").each(function() {
            var width = $(this).width ();
            $(this).css("height", width / 1.4 + "px");
        });
    }
});

$(document).ready(function () {
    $(".show-all").click(function (e) {
        e.preventDefault();
        $(".hidden-slot").css('display', 'block');
        $(".has-btn").css('display', 'none');
    });
    $('#showMenu').click(function () {
        $(this).toggleClass('open');
        $('.h-item-menu').animate({'width': 'toggle'}, 100);
    });
    $('#close-menu').click(function () {
        $('#showMenu').toggleClass('open');
        $('.h-item-menu').animate({'width': 'toggle'}, 100);
    });
    $('nav.header-menu ul li a').click(function () {
        if ($('#close-menu').css('display') == 'block') {
            $('#showMenu').toggleClass('open');
            $('.h-item-menu').animate({'width': 'toggle'}, 100);
        }
    });
    $('.slider-wrap').slick({
        dots: true,
        arrows: false,
        autoplay: true,
        infinite: false,
        appendDots: $('.slider-nav'),
    });
});

var activeClass = 'active',
    ariaAttribute = 'aria-hidden';
$('.slider-wrap')
    .on( 'init', function() {
        $( '.slider-wrap .slick-dots li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, false );
    } )
    .on( 'afterChange', function( event, slick, currentSlide ) {
        var $dots = $( '.slick-dots' );
        $( 'li', $dots ).removeClass( activeClass ).attr( ariaAttribute, true );
        $dots.each( function() {
            $( 'li', $( this ) ).eq( currentSlide ).addClass( activeClass ).attr( ariaAttribute, false );
        } );
    } );

document.addEventListener("DOMContentLoaded", readyHTML);
function readyHTML() {
    jekpot_count('.jek-pot-count');

}
function jekpot_count(container) {
    var curent_container = document.querySelector(container);
    if (curent_container) {
        _winjacpot(curent_container);
    }
    function _winjacpot(el) {
        var default_val = 1000000, //стартовое значение, которое увидит пользователь при первой загрузке страницы
            minimum_val = 1000000, //к этому значению будет сброшено число, когда перевалит максимальное значение
            maximum_val = 2000000, //максимальное значение числа
            current = 0, //тут будет хранится текущее значение числа
            min = 0, //минимальное приращениеk
            max = 1, //максимальное приращение
            min_time = 3000, //мин.временной интервал обновления
            max_time = 6000, //макс.временной интервал обновления
            timer = '', //здесь будет хранится рекурсивный вызов таймера
            time = '', //а здесь - случайный временной интервал
            method = {}; //методы (функции)
        type = 'jekpot';
        method.init = function () {
            //получим значение числа из localStorage
            current = parseFloat(localStorage.getItem('winValue'+type)); //сразу преобразуем в число
            if (!current) {//если его там нет - установим дефолтное
                method.save(default_val);
            }
            method.show(current); //отобразим на странице

            //рекурсивный setTimeot, в который передадим случайный временной интервал time
            time = method.getRandomTime();
            timer = setTimeout(function tick() {
                method.add();//увеличили значение числа на случайную величину и отобразили на странице
                time = method.getRandomTime();
                timer = setTimeout(tick, time);
            }, time);
        };

        method.save = function (val) {//запишем текущее значение в localStorage
            try {
                saveToStorage();
            } catch (e) {
                if (e == QUOTA_EXCEEDED_ERR) {//если оно переполнено - очистим и запишем повторно
                    localStorage.clear();
                    saveToStorage();
                }
            }
            function saveToStorage() {
                localStorage.setItem('winValue'+type, val);
                current = val;
            }
        };

        method.show = function (val) { //отобразим текущее значение на странице, предварительно преобразовав число в нужный формат
            var num_array = String(val).split('');
            var data_num = el.querySelectorAll('span');
            if (data_num) {
                for (var j = 0; j < data_num.length; j++) {
                    if (num_array[j]) {
                        data_num[j].setAttribute('data-number',num_array[j]);
                        data_num[j].innerHTML = num_array[j];
                    } else {
                        data_num[j].remove();
                    }
                }
            } else {
                for (var i = 0; i < num_array.length; i++) {
                    if (i == 0 ) {
                        el.innerHTML += '<span data-number="'+num_array[i]+'">'+num_array[i]+'</span>';

                        el.innerHTML += '<div class="currency">&#8381;</div>';
                    } else {
                        el.innerHTML += '<span data-number="'+num_array[i]+'"></span>';
                    }
                    if ( i == (num_array.length-1)) {
                        el.innerHTML += '<span class="currency"></span>';
                    }
                }
            }
        };
        method.add = function () {//увеличим значение числа на случайную величину
            // будем брать значение из localStorage а не из переменной, т.к. страница может быть открыта в двух вкладках (например) и это позволит частично их синхронизировать
            current = parseFloat(localStorage.getItem('winValue'+type)) + Math.round((Math.random() * (max - min) + min) * 100); //увеличим на случайное число, округленное до целого
            if (current > maximum_val) {//если перевалили за максимум - сбросим к минимуму
                current = minimum_val;
            }
            method.save(current); //сохранили в localStorage
            method.show(current); //вывели на экран
        };
        method.getRandomTime = function () {//вернем случайный целый интервал от 200 до 8000 милисекунд
            return Math.floor(Math.random() * (max_time - min_time + 1)) + min_time;
        };
        method.init();
    }
}


document.addEventListener("DOMContentLoaded", function (event) {
    window.onscroll = function () {
        fixedIsActive()
    };
    var toTopButton = document.getElementById("toTop");

    function fixedIsActive() {
        if (window.pageYOffset > 50) {
            toTopButton.classList.add("fixed");
        } else {
            toTopButton.classList.remove("fixed");
        }
    }

    toTopButton.onclick = scrollToTop;

    function scrollToTop() {
        window.scrollTo({top: 0, behavior: 'smooth'});
    }
});